import { Box } from '@mui/material';
import { Banner } from '../../../interfaces/Banner/Banner';
import { ComponentStyle } from '../../../interfaces/Settings/SettingsV2/ComponentStyle';
import { EditableStyleWrapper } from '../StyleEditor/EditableStyleWrapper';

type BannerContainerProps = {
  banner: Banner;
  maxHeight?: number;
  styleOverride?: ComponentStyle;
  stylePath?: string;
};

export const BannerContainer = ({
  banner,
  maxHeight,
  styleOverride,
  stylePath,
}: BannerContainerProps) => {
  const inner = (
    <Box
      component='img'
      src={banner.image}
      alt={banner.title}
      sx={{
        width: '100%',
        height: 'auto',
        maxHeight,
        cursor: banner.linkUrl ? 'pointer' : undefined,
        transition: 'transform 0.5s',
        display: 'block', // remove bottom spacing from inline img
        '&:hover': {
          transform: 'scale(1.1)',
        },
        ...styleOverride,
      }}
    />
  );

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden', // clip the image when it scales
        position: 'relative',
      }}
    >
      {stylePath ? (
        <EditableStyleWrapper path={stylePath}>{inner}</EditableStyleWrapper>
      ) : (
        inner
      )}
    </Box>
  );
};
